import { connect } from 'react-redux';

import { setSwitchPfeSktAction } from '../actions/accountSettingsAction';
import {
  deleteCustomPlaylist,
  getCustomPlaylists,
} from '../actions/customAudioPlaylistActions';
import { updateAudioPlaylistProgress } from '../actions/studyMainActions';
import * as studyTypes from '../actions/studyMainActionTypes';
import {
  getSwitchPfeSkt,
  getUserSubscription,
} from '../components/AccountSettings/AccountSettingsSelectors';
import AudioStudyView from '../components/AudioStudy/AudioStudyView';
import {
  getAudioPlaylistSelector,
  getAudioPlaylistsProgressSelector,
  getContentByRefSelector,
  isLoadingReferences,
} from '../components/Study/studyMainSelectors';
import { getUser } from '../components/User/userSelectors';

const mapStateToProps = (state) => {
  const user = getUser(state);
  const userSubscription = getUserSubscription(state);
  const pfeSktId = getSwitchPfeSkt(state);

  const contentByRef = getContentByRefSelector(state);
  const contentByRefJs = contentByRef?.toJS
    ? contentByRef.toJS()
    : contentByRef;

  const references = Array.isArray(contentByRefJs?.references)
    ? contentByRefJs.references
    : [];

  return {
    user,
    userSubscription,
    pfeSktId,
    customPlaylists: state.customAudioPlaylist.playlists,
    customPlaylistsLoading: state.customAudioPlaylist.loading,
    references,
    loadingReferences: !!isLoadingReferences(state),
    currentPlaylist: getAudioPlaylistSelector(state),
    audioPlaylistsProgress: getAudioPlaylistsProgressSelector(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  setSwitchPfeSkt: (rateId) => dispatch(setSwitchPfeSktAction(rateId)),

  getContentByReference: (rateId) =>
    dispatch({
      type: studyTypes.GET_CONTENT_BY_REFERENCE,
      rate: { id: rateId },
    }),

  getCustomPlaylists: () => dispatch(getCustomPlaylists()),
  deleteCustomPlaylist: (playlistId) =>
    dispatch(deleteCustomPlaylist(playlistId)),

  getAudioPlaylist: (chapterId) =>
    dispatch({ type: studyTypes.GET_AUDIO_PLAYLIST, chapterId }),

  getAudioPlaylistProgress: (chapterIds) =>
    dispatch({
      type: studyTypes.GET_AUDIO_PLAYLISTS_PROGRESS,
      payload: { chapterIds },
    }),

  updateAudioPlaylistProgress: (
    chapterId,
    nextQuestionId,
    status,
    restartPlaylist = false,
  ) =>
    dispatch(
      updateAudioPlaylistProgress(
        chapterId,
        nextQuestionId,
        status,
        restartPlaylist,
      ),
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(AudioStudyView);
